import {useEffect,useState} from 'react';
// Track overlapping playback independently so ending one sound cannot clear another.
export function useSoundboardActivity(){
 const [users,setUsers]=useState<Set<string>>(new Set());
 useEffect(()=>{
  const playing=new Map<string,string>();
  const update=(event:Event)=>{
   const d=(event as CustomEvent).detail;
   if(!d||typeof d.userId!=='string'||typeof d.playbackId!=='string')return;
   if(d.active)playing.set(d.playbackId,d.userId);else playing.delete(d.playbackId);
   setUsers(new Set(playing.values()));
  };
  window.addEventListener('malvo-soundboard-activity',update);
  return()=>window.removeEventListener('malvo-soundboard-activity',update);
 },[]);
 return users;
}
